module.exports = __webpack_public_path__ + "img/body-3-lg.34ab11f0.png";